import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar, GridPagination,} from '@mui/x-data-grid';
import { Link, useParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function SalesGstReport(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [addedby, setAddedby] = useState({ username: '' });
  const [mode, setMode] = useState({ mode: '' });
  const [rows, setRows] = useState([]);
  const [userData, setUserData] = useState([]);
  const [combinedData, setcombinedData] = useState([]);
  const [viewPharmData, setViewPharmData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
 const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};
  const handleUser = (event) => {
      setAddedby({
        ...addedby,
        username: event.target.value
      });
    };
    const handleMode = (event) => {
      setMode({
        ...mode,
        mode: event.target.value
      });
    };
  useEffect(() => {
    try {
        axios.get(`${baseUrl}user-search/`)
        .then(function (response) {
            setUserData(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
      fetchData();
  }, [startDate, endDate, addedby, mode]);

  function fetchData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}all-pharm-sale/?start_date=${startDateString}&end_date=${endDateString}&addedby=${addedby.username}&mode=${mode.mode}&status=1`;
  axios.get(url)
    .then(response => {
      const filteredData = response.data.filter(item => item.mode !== 'Indent');
      setcombinedData(filteredData);
      setRows(filteredData)
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }

const columns = [
  { field: 'add_date_date', headerName: 'Date', width: 120 },
  { field: 'pat__patient', headerName: 'Patient', width: 150 },
  { field: 'mode', headerName: 'Mode', width: 80 },
  {
    field: 'sale_id',
    headerName: 'Invoice No',
    renderCell: (params) => {
      let invoiceLink = '';
      if (params.row.sale_type === 'IndentBill') {
        invoiceLink = `/pharm-invoice-indent/${params.row.sale_id}`;
      } else {
        invoiceLink = `/pharm-invoice-other/${params.row.sale_id}`;
      }
      return (
        <Link to={invoiceLink} target="_blank">
          {params.row.sale_id}
        </Link>
      );
    },
    width: 120
  },

  { field: 'gstTotal', headerName: 'Drug Amount', width: 100 },
  { field: 'gstAmountTotal', headerName: 'CGST', width: 100 },
  { field: 'gstAmountTotal1', headerName: 'SGST', width: 100 },
  { field: 'total', headerName: 'Invoiced Amount', width: 100 },
  { field: 'addedby', headerName: 'Cashier', width: 80 },
];

  const getTotal = (rows, field) => {
  return rows.reduce((totals, row) => {
    const value = parseFloat(row[field]);
    if (!isNaN(value)) {
      return totals + value;
    }
    return totals;
  }, 0);
};


const Footer = ({ rows }) => {
  const totalDrugAmount = getTotal(rows, 'gstTotal');
  const totalTotAmount = getTotal(rows, 'total');
  const totalGstAmount = getTotal(rows, 'gstAmountTotal');
  const totalGstAmount1 = getTotal(rows, 'gstAmountTotal1');

  return (
    <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '8px' }}>
      <div>Total</div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div>{totalDrugAmount?.toFixed(2)}</div>
      <div>{totalGstAmount?.toFixed(2)}</div>
      <div>{totalGstAmount1?.toFixed(2)}</div>
      <div>{totalTotAmount?.toFixed(2)}</div>
    </div>
  );
};

  const today = new Date();

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Sales GST Report</h3>
      <div className="row">
        <div className="col-md-4">
            <label className="control-label">Select Date</label>
            <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText={'Please select From date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={today}
                placeholderText={'Please select To date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>

            <div className="col-md-4">
            <div className="mb-4 mt-4 form-control">
              <label htmlFor="user" className="form-label">Search by Cashier</label>
              <select name="user" id="username" value={addedby.user} className="form-control"
                            onChange={(event) => handleUser(event)}>
                            <option value="">Select Cashier</option>
              {userData.map((User,index) => (
                <option key={index} value={User.username}>{User.username}</option>
              ))}
            </select>
            </div>
            </div>
            <div className="col-md-4">
            <div className="mb-4 mt-4 form-control">
              <label htmlFor="mode" className="form-label">Search by Sales Mode</label>
              <select name="mode" id="mode" value={mode.mode} className="form-control"
                onChange={(event) => handleMode(event)}>
                <option value="">Select Sales Mode</option>
                <option value="cash">Cash</option>
                <option value="card">Card</option>
                <option value="creditpay">Credit Payment</option>
                <option value="advance">Advance</option>
                <option value="UPI">UPI</option>
              </select>
            </div>
            </div>
      </div>

  {!isLoading && combinedData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rows}
            columns={columns}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,
              Pagination: GridPagination,
            }}
            autoHeight
          />
          <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tfoot>
              <Footer rows={rows} />
            </tfoot>
          </table>
        </div>
      ) : (
        <>loading pls wait....</>
      )}
    </section>
  )
}

export default SalesGstReport;
